import React, { type SyntheticEvent } from 'react';
import { useTranslation } from '@/app/components/translations/Translation';
import { CtaLabel, CtaSpinner, CtaV2 } from '../Cta/styled';
import { FooterContainer, type FooterLayout } from './styled';

type Props = {
  applyText?: string;
  handleApply: (e: SyntheticEvent) => void;
  isApplyDisabled?: boolean;
  isApplyLoading?: boolean;
  clearText?: string;
  handleClear?: (e: SyntheticEvent) => void;
  isClearDisabled?: boolean;
  sticky?: boolean;
  showShadow?: boolean;
  layout?: FooterLayout;
} & React.HTMLAttributes<HTMLDivElement>;

const BasicModalFooterV2 = ({
  applyText,
  handleApply,
  isApplyDisabled,
  isApplyLoading,
  clearText,
  handleClear,
  isClearDisabled,
  sticky,
  showShadow,
  layout,
  ...rest
}: Props) => {
  const { t } = useTranslation();
  const isAligned = layout === 'right' || layout === 'left' || layout === 'centered';

  return (
    <FooterContainer hasClear={!!handleClear} $sticky={sticky} $showShadow={showShadow} $layout={layout} {...rest}>
      {handleClear && (
        <CtaV2
          isClear={true}
          hasMinWidth={!isAligned}
          isBold={!isAligned}
          onClick={handleClear}
          isDisabled={isClearDisabled}
          disabled={isClearDisabled}
        >
          {clearText || t('vacation.oss.filters.clear')}
        </CtaV2>
      )}
      {handleApply && (
        <CtaV2
          hasMinWidth={!isAligned}
          isBold={!isAligned}
          onClick={handleApply}
          isDisabled={isApplyDisabled || isApplyLoading}
          disabled={isApplyDisabled || isApplyLoading}
          {...(isApplyLoading ? { 'aria-label': t('vacation.oss.components.searchfilters.main.loading') } : {})}
        >
          {isApplyLoading && <CtaSpinner variant="accent" size={16} thickness={2} />}
          <CtaLabel $hidden={isApplyLoading}>{applyText || t('vacation.oss.filters.apply')}</CtaLabel>
        </CtaV2>
      )}
    </FooterContainer>
  );
};

export type { FooterLayout } from './styled';
export default BasicModalFooterV2;
